module.exports = __webpack_public_path__ + "images/e8c4e2a4b518f942b2ebd33786418d4e.png";